/**
 * This is used like the lazy load we have on photos but instead we load components
 */
export default {
    //twoWay: true,
    bind(el, binding, vnode) {
        if (!("IntersectionObserver" in window)) {
            return false;
        }

         let intersect = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.intersectionRatio > 0) {
                    vnode.context.$nextTick(() => {
                        vnode.context.setPath(vnode.context, binding.expression, true );
                    });
                    intersect.unobserve(el);
                }
            });
        });
        intersect.observe(el);

        // Listen for signal to reset carousel
        vnode.context.$on('carousel-first-slide', () => {
            vnode.context.$nextTick(() => {
                vnode.context.setPath(vnode.context, binding.expression, true );
            });
        });
    },
    update(el, binding, vnode) {

    }
}
